var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseArtist',{attrs:{"artist":_vm.artist,"artist-banners":_vm.artistBanners,"events":_vm.events,"is-mobile":_vm.isMobile,"is-msg-hidden":_vm.isMsgHidden,"msg-content":_vm.msgContent,"msg-subtitle":_vm.msgSubTitle,"msg-title":_vm.msgTitle}})
}
var staticRenderFns = []

export { render, staticRenderFns }